import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.K1y1Mm',
    defaultMessage: 'Create new app collection',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  create: {
    id: 'studio.P1WzdG',
    defaultMessage: 'Create app collection',
  },
  error: {
    id: 'studio.7BnPwg',
    defaultMessage: 'Something went wrong when creating this app collection.',
  },
  nameConflict: {
    id: 'studio.uRCjuc',
    defaultMessage: 'An app collection with this name already exists in this organization.',
  },
});
